import {Component, OnInit} from '@angular/core';
import {Product} from '../../model/product';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {

  constructor(private http: HttpClient) {
  }

  productList: Product[];
  search: string;

  ngOnInit(): void {
    this.getProducts();
  }

  getProducts() {
    this.http.get<Product[]>('/assets/data/products.json').subscribe(p =>
      this.productList = p);
  }

}
